import React from 'react'
import PropTypes from 'prop-types'
import { helpers } from '../../helpers'

/* doc
---
title: Price
name: Price
category: React - Core
---

A `Price` component renders a price value, or a range of prices. Use this any
time you want to display a monetary value.


### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| prices          | Array of price/prices to display              | array          | []                        | no            |

```html_example
  <Price prices={[4.99, "12.99"]} />
```
*/
function Price(props) {
  const { className, prices, ...rest } = props

  /**
  * Renders a single price value.
  */
  const renderPrice = (price, idx) => {
    const number = helpers.formatNumber(price, 2)

    if (!number) {
      return false
    }

    const amount = number.split('.')

    if (!amount.length === 2) {
      return false
    }

    return (
      <span className="price-value" key={idx}>
        <span className="price-symbol">$</span>
        <span className="price-amount">{amount[0] || '0'}</span>
        <span className="price-fraction">.{amount[1] || '00'}</span>
      </span>
    )
  }

  const classes = [
    'price-range',
    className || '',
  ]

  return (
    <span {...rest} className={classes.join(' ')}>
      {prices.map((price, idx) => renderPrice(price, idx))}
    </span>
  )
}

Price.defaultProps = {
  prices: [],
}

Price.propTypes = {
  // List of numbers to display, should be either 1 or 2 values.
  prices: PropTypes.array,
}

export default Price
